import { History } from 'history';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { parseQuery } from '../utils/helpers';

function usePagination(
  defaultPage: number = 1,
  hideParam: boolean,
): [number, (page: number) => void] {
  const history: History = useHistory();
  const [page, setPage] = useState(defaultPage);
  const { pathname, search } = history.location;
  const queryParams = parseQuery(search);

  useEffect(() => {
    const initialFirstPage = defaultPage === 1 && page === 1;
    const hasVideoId = queryParams.video;
    if (!hideParam && !hasVideoId) {
      const initialUrl = `${pathname}${search}`;
      const nextPageSearch = new URLSearchParams(search);
      nextPageSearch.append('page', page.toString());
      const nextPageUrl = `${pathname}?${nextPageSearch.toString()}`;
      history.replace(initialFirstPage ? initialUrl : nextPageUrl);
    }
  }, [page]);

  return [page, setPage];
}

export default usePagination;
